// 获取站点配置
import {getSiteSetting} from "../../api/base/platform";
import {getEnumLevelList, getEnumMonthList, getRegionEnum} from "../../api/base/enum";
import {getRegion, getRegionOptions, setRegion, setRegionOptions} from "../../utils/region";

const state = {
  siteSetting: {},
  // 可选月份列表
  monthList: [],
  //  开始月份
  startMonth: '',
  //  结束月份
  endMonth: '',
  // 客户级别
  // levelOptions: []
};

const mutations = {
  // 更新可选月份列表
  SET_MONTH_LIST(state, monthList) {
    state.monthList = monthList;
    const sortedMonths = monthList.sort(); // 按字符串排序，从最早到最晚
    state.startMonth = sortedMonths[0]; // 更新最早的时间
    state.endMonth = sortedMonths[sortedMonths.length - 1]; // 更新最晚的时间
  },

  SET_SITE_SETTING(state, data) {
    state.siteSetting = data;
  },

  // SET_LEVEL(state, data) {
  //   state.levelOptions = data;
  // }
};

const actions = {
  // 初始化系统配置
  initSetting({commit,state},from) {
    let requests = [];
    //  判断是否需要重新获取站点配置
    const isLogin = Boolean( from.path === '/' && (from.meta && from.meta.title));
    if (!(state.siteSetting && JSON.stringify(state.siteSetting) !== '{}') || isLogin) {
      requests.push({request: getSiteSetting(), key: 'site'});
    }
    // if (!(state.monthList && state.monthList.length > 0) || isLogin) {
    //   requests.push({request: getEnumMonthList(), key: 'month'});
    // }
    // if (!(state.levelOptions && state.levelOptions.length > 0) || isLogin) {
    //   requests.push({request: getEnumLevelList(), key: 'level'});
    // }
    const region = getRegionOptions();
    if (!(region && region.length > 0) || isLogin) {
      requests.push({request: getRegionEnum(), key: 'region'});
    }
    if (requests.length === 0) {
      return Promise.resolve([]);
    }
    return new Promise((resolve, reject) => {
      Promise.all(requests.map(req => req.request))
        .then(results => {
          results.forEach((result, index) => {
            const key = requests[index].key;
            if (result.success) {
              if (key === 'site') {
                commit('SET_SITE_SETTING', result.data);
              }
              //  else if (key === 'month') {
              //   commit('SET_MONTH_LIST', result.data);
              // }
              // else if (key === 'level') {
              //   commit('SET_LEVEL', result.data);
              // }
              else if (key === 'region') {
                const options = result.data || [];
                setRegionOptions(options)
                if (!getRegion()) {
                  setRegion('us-east-1')
                }
              }
            } else {
              console.error(result.message);
            }
          });
          resolve(results);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  // 更新系统站点配置
  updateSiteSetting({commit}) {
    return new Promise((resolve, reject) => {
      getSiteSetting().then(response => {
        const {data} = response;
        commit('SET_SITE_SETTING', data);
        resolve(data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  // 获取可选月份列表
  updateMothList({commit}) {
    return new Promise((resolve, reject) => {
      getEnumMonthList().then(response => {
        const {data} = response;
        commit('SET_MONTH_LIST', data);
        resolve(data);
      }).catch(error => {
        reject(error);
      });
    });
  },
};

const getters = {
  // 是否需要加载系统资源
  needLoadResource: state => (from) => {
    return Boolean( from.path === '/' && (from.meta && from.meta.title)) ||
    !(state.siteSetting && JSON.stringify(state.siteSetting) !== '{}') ||
    !(state.monthList && state.monthList.length > 0) ||
    !(getRegionOptions() && getRegionOptions().length > 0)
  },
};


export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/setting.js